import { LinkedSectionsModel } from '../../sections/models/linked_sections_model';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { LoadCrossCourseLinkedSectionsFacade } from '../../sections/facades/load_cross_course_linked_sections_facade';

export type GetSectionAvailabilityCommand = (
  termId: number,
  courseId: number,
  sectionTypeId: number,
  urlParams: string
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getSectionAvailabilityCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      ngLinkedSectionsModel: LinkedSectionsModel,
      $q: ng.IQService,
      ngLoadCrossCourseLinkedSectionsFacade: LoadCrossCourseLinkedSectionsFacade
    ): ICommand => {
      return defineCommandORM(
        'getSectionAvailabilityCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          termId: number,
          courseId: number,
          sectionTypeId: number,
          urlParams: string = ''
        ) => {
          $http({
            method: 'GET',
            url: `reg/sections/availability/term/${termId}/course/${courseId}/section_type/${sectionTypeId}/${urlParams}`
          })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              const missingSections = ngLoadCrossCourseLinkedSectionsFacade.loadCrossCourseLinkedSections(
                data.section_link
              );
              ngLinkedSectionsModel.write(data.section_link);
              ngSectionAvailabilityDatasource.write(data.section_status);
              return $q.all(missingSections).then(() => deferred.resolve());
            })
            .catch(deferred.reject);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/get_unscheduled_sections_availability_command.ts